import { render } from "./QaTestCaseBoard.vue?vue&type=template&id=064921aa&scoped=true"
import script from "./QaTestCaseBoard.vue?vue&type=script&lang=js"
export * from "./QaTestCaseBoard.vue?vue&type=script&lang=js"

import "./QaTestCaseBoard.vue?vue&type=style&index=0&id=064921aa&scoped=true&lang=css"
import "./QaTestCaseBoard.vue?vue&type=style&index=1&id=064921aa&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064921aa"]])

export default __exports__